import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
function EditCgp({
  backUrl,
  api,
  fetchData,
  getType,
  getPP,
  getTypePersonne,
  getPM,
  getTeteReseau,
  getTaux,
  getModele,
  getCodeInvest,
  //render

  renderOuiNonOptions,
  renderPmOptions,
  renderTauxOptions,
  renderTeteReseauOptions,
  renderTypePersonneOptions,
  renderPpOptions,
  renderModeleOptions,
  renderTypeOptions,
  renderCodeOptions,

  // handle
  handleCodeChange,
  handleActifChange,
  handleTauxChange,
  handleTypeChange,
  handleTypePersonneChange,
  handleDefautChange,
  handleCompteCreanceChange,
  handleTrigrammeChange,
  handlePersonneChange,
  handlePmChange,
  handleNumeroChange,
  handleTeteReseauChange,
  handleEntrepreteurChange,
  handleModeleChange,
  handleModeleTChange,
  handleOrigineChange,
  handleCodeInvesChange,
  //exploitant
  handleComptableChange,
  handleDataCreaChange,
  handleImpactChange,
  handleMatChange,
  handleSecteurChange,
  handleSurfaceConsChange,
  handleSurfaceExpChange,
  handleSurfaceTotChange,
  // requete
  handleSubmitP,
  handleSubmitPm,
  //variables
  selectedTaux,
  selectedActif,
  selectedCode,
  selectedCompteCreance,
  selectedDefaut,
  selectedEntrepreteur,
  selectedModele,
  selectedModeleT,
  selectedNumero,
  selectedOrigine,
  selectedPersonnePhysique,
  selectedPm,
  selectedTeteReseau,
  selectedTrigramme,
  selectedType,
  selectedTypePersonne,
  // exploitant
  selectedComptable,
  selectedDataCrea,
  selectedImpact,
  selectedMat,
  selectedSecteur,
  selectedSurfaceCons,
  selectedSurfaceExp,
  selectedSurfaceTot,
  //Direction produit
  selectedCodeInves,
  // variable données
  IdentificationData,
  DonneesComplementData,
  DonneesComplementDirectionData,
  DonneesComplementExploitantData,
  // custom
  CustomNavTabs,
  activeTab,
  Titre,
  TitrePage,
  colStyle,
}) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        await fetchData();
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchDataAsync();
  }, []);

  useEffect(() => {
    if (!loading) {
      getType();
      getPP();
      getTypePersonne();
      getPM();
      getTeteReseau();
      getTaux();
      getModele();
      getCodeInvest();
    }
  }, [loading]);

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/${api}/`}
                          style={{
                            color: "#3c88c8",
                            textDecoration: "underline !important",
                          }}
                        >
                          {TitrePage}
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          Titre
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-info"
                          onClick={
                            selectedTypePersonne?.label == "PP"
                              ? handleSubmitP
                              : handleSubmitPm
                          }
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    {" "}
                                    Identification
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(IdentificationData).map(
                                      ([key, value], index) => (
                                        <Row className="mb-3" key={index}>
                                          {key === "Type" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedType}
                                                  onChange={handleTypeChange}
                                                  options={renderTypeOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedType === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Type ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Personne Physique" &&
                                            selectedTypePersonne?.label ==
                                              "PP" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={
                                                    selectedPersonnePhysique
                                                  }
                                                  onChange={
                                                    handlePersonneChange
                                                  }
                                                  options={renderPpOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedPersonnePhysique ===
                                                null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Personne physique ne peut
                                                    pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Personne Morale" &&
                                            selectedTypePersonne?.label ==
                                              "PM" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedPm}
                                                  onChange={handlePmChange}
                                                  options={renderPmOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedPm == null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Personne Morale ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Personne Morale" &&
                                            selectedTypePersonne?.label ==
                                              "PP" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    Personne Physique* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={
                                                    selectedPersonnePhysique
                                                  }
                                                  onChange={
                                                    handlePersonneChange
                                                  }
                                                  options={renderPpOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedPersonnePhysique ===
                                                null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Personne physique ne peut
                                                    pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Personne Physique" &&
                                            selectedTypePersonne?.label ==
                                              "PM" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    Personne Morale* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedPm}
                                                  onChange={handlePmChange}
                                                  options={renderPmOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedPm === null ||
                                                selectedPm === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Personne Morale ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Type personne" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={
                                                    selectedTypePersonne
                                                  }
                                                  onChange={
                                                    handleTypePersonneChange
                                                  }
                                                  options={renderTypePersonneOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedTypePersonne ===
                                                null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Type personne ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "N° RCS" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedNumero}
                                                  required
                                                  onChange={handleNumeroChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Code APE" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedCode}
                                                  required
                                                  onChange={handleCodeChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Actif" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedActif}
                                                  onChange={handleActifChange}
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedActif === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Actif ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Défaut" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedDefaut}
                                                  onChange={handleDefautChange}
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Trigramme" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedTrigramme
                                                  }
                                                  required
                                                  onChange={
                                                    handleTrigrammeChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Tête de réseau" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={
                                                    selectedTeteReseau
                                                  }
                                                  onChange={
                                                    handleTeteReseauChange
                                                  }
                                                  options={renderTeteReseauOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                                {selectedTeteReseau === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Tête de réseau ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : null}
                                        </Row>
                                      )
                                    )}
                                  </CardBody>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    {" "}
                                    Données complémentaires CGP
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(DonneesComplementData).map(
                                      ([key, value], index) => (
                                        <Row className="mb-3" key={index}>
                                          {key === "Origine" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedOrigine}
                                                  required
                                                  onChange={handleOrigineChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Taux d'apport (restriction)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "0px",
                                                      textWrap: "wrap",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedTaux}
                                                  onChange={handleTauxChange}
                                                  options={renderTauxOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  isMulti={true}
                                                />
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Modèle dossier de souscription" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",

                                                      textWrap: "wrap",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedModele}
                                                  onChange={handleModeleChange}
                                                  options={renderModeleOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Modèle dossier de souscription TEPA" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      textWrap: "wrap",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={selectedModeleT}
                                                  onChange={handleModeleTChange}
                                                  options={renderModeleOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Entrepreteurs" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "11em",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="mb-2 col-md-8">
                                                <Select
                                                  defaultValue={
                                                    selectedEntrepreteur
                                                  }
                                                  onChange={
                                                    handleEntrepreteurChange
                                                  }
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : null}{" "}
                                        </Row>
                                      )
                                    )}
                                  </CardBody>
                                </Card>
                                <Row>
                                  <Col sm="12">
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{
                                          paddingLeft: "10px",
                                        }}
                                      >
                                        {" "}
                                        Données complémentaires Direction
                                        produit
                                      </CardTitle>
                                      <CardBody>
                                        {Object.entries(
                                          DonneesComplementDirectionData
                                        ).map(([key, value], index) => (
                                          <Row className="mb-3" key={index}>
                                            {key === "Compte de créance" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        width: "11em",
                                                        paddingTop: "10px",
                                                      }}
                                                    >
                                                      {key} :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col className="mb-2 col-md-8">
                                                  <input
                                                    className="form-control"
                                                    defaultValue={
                                                      selectedCompteCreance
                                                    }
                                                    required
                                                    onChange={
                                                      handleCompteCreanceChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key ===
                                              "Code d'investissement par défaut" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        width: "10em",

                                                        textWrap: "pretty",
                                                      }}
                                                    >
                                                      {key} :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col className="mb-2 col-md-8">
                                                  <Select
                                                    defaultValue={
                                                      selectedCodeInves
                                                    }
                                                    onChange={
                                                      handleCodeInvesChange
                                                    }
                                                    options={renderCodeOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                  />
                                                </Col>
                                              </>
                                            ) : null}
                                          </Row>
                                        ))}
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                                {Object.keys(DonneesComplementExploitantData)
                                  .length > 0 ? (
                                  <Row>
                                    <Col sm="12">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                          }}
                                        >
                                          {" "}
                                          Données complémentaires exploitant
                                        </CardTitle>

                                        <CardBody>
                                          {Object.entries(
                                            DonneesComplementExploitantData
                                          ).map(([key, value], index) => (
                                            <Row className="mb-3" key={index}>
                                              {key ===
                                              "Matériel d'exploitation" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={selectedMat}
                                                      required
                                                      onChange={handleMatChange}
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}

                                              {key === "Comptable" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <Select
                                                      defaultValue={
                                                        selectedComptable
                                                      }
                                                      onChange={
                                                        handleComptableChange
                                                      }
                                                      options={renderPpOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}

                                              {key ===
                                              "Date création activité" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <InputMask
                                                      mask="99/99/9999"
                                                      value={selectedDataCrea}
                                                      className="form-control input-color"
                                                      onChange={
                                                        handleDataCreaChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key ===
                                              "Secteur d'activité de l'exploitant" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",

                                                          textWrap: "wrap",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedSecteur
                                                      }
                                                      required
                                                      onChange={
                                                        handleSecteurChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key ===
                                              "Surface construite (m²)" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "10em",

                                                          textWrap: "wrap",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedSurfaceCons
                                                      }
                                                      required
                                                      onChange={
                                                        handleSurfaceConsChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key ===
                                              "Surface exploitée (ha)" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "9em",

                                                          textWrap: "wrap",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedSurfaceExp
                                                      }
                                                      required
                                                      onChange={
                                                        handleSurfaceExpChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key ===
                                              "Surface totale détenue (ha)" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "9em",

                                                          textWrap: "wrap",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedSurfaceTot
                                                      }
                                                      required
                                                      onChange={
                                                        handleSurfaceTotChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}

                                              {key === "Impact sur l'emploi" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="mb-2 col-md-8">
                                                    <input
                                                      className="form-control"
                                                      defaultValue={
                                                        selectedImpact
                                                      }
                                                      required
                                                      onChange={
                                                        handleImpactChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                            </Row>
                                          ))}
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                ) : null}
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditCgp;
